import TabBar from './TabBar.component';

export default TabBar;
